export const NOT_ENOUGH_RIGHTS = 'NOT_ENOUGH_RIGHTS';

export const notEnoughEights = payload => ({
  type: NOT_ENOUGH_RIGHTS,
  payload,
});
